import React, { useEffect, useState } from "react";
import { navigate, prefetchPathname } from "gatsby";
import { tl } from "./FiyatGecmisi";
import "./urunKarti.css";

// Mağaza adı renkleri (subheader'a göre)
const MAGAZA_RENGI = { Trendyol: "#f27a1a", Hepsiburada: "#ff6000", Amazon: "#e47911", MediaMarkt: "#df0000", "Vatan Bilgisayar": "#1d4ed8" };
// Elektronik servisinden gelen kayıtta mağaza kodu (urun_indirim.magaza): kartta mağazanın kendi adı yazar
const MAGAZA_KODU_ADI = { MEDIAMARKT: "MediaMarkt", VATAN: "Vatan Bilgisayar" };

const sayiyaCevir = (v) => {
    if (v == null) return null;
    const n = Number(String(v).replace(/[^\d.,-]/g, "").replace(",", "."));
    return isNaN(n) || n <= 0 ? null : n;
};

/** "12 dk önce" (tarayıcıda hesaplanır: SSR ile saat farkı olmasın). */
function neKadarOnce(tarih) {
    const dk = Math.floor((Date.now() - new Date(tarih).getTime()) / 60000);
    if (isNaN(dk) || dk < 0) return null;
    if (dk < 1) return "az önce";
    if (dk < 60) return dk + " dk önce";
    if (dk < 60 * 24) return Math.floor(dk / 60) + " saat önce";
    return Math.floor(dk / (60 * 24)) + " gün önce";
}

/**
 * Kartın görsel üstü etiketleri, indirim kaydından (liste uçlarının UrunIndirim alanları): en düşük fiyat, kupon, kod,
 * sepet indirimi, üyelik fiyatı, kargo. En fazla 2 tane (önem sırasıyla). Eskiden her karta "Flaş" yazılıyordu; artık
 * hepsi o durumda yayınlandığı için bilgi taşımıyordu.
 */
export function kartEtiketleri(x) {
    if (!x) return [];
    const l = [];
    const yeni = sayiyaCevir(x.yeniFiyat), enDusuk = sayiyaCevir(x.enDusukFiyat);
    const takipGun = x.takipBaslangicTarihi ? (Date.now() - new Date(x.takipBaslangicTarihi).getTime()) / 864e5 : 0;
    if (yeni && enDusuk && yeni <= enDusuk && takipGun >= 30) l.push({ ad: "En düşük fiyat", tur: "yesil" });
    const promo = (x.promotionName || "") + " " + (x.exstraKampanya || "") + " " + (x.kampanya1 || "");
    if (x.toplanabilirKuponVarMi === true || /kupon/i.test(promo)) l.push({ ad: "Kuponlu" });
    if (x.fiyatKaynagi === "KOD" || /kod:/i.test(promo)) l.push({ ad: "Kodla indirim" });
    else if (/sepette/i.test(promo)) l.push({ ad: "Sepette indirim" });
    if (x.fiyatKaynagi === "TY_PLUS") l.push({ ad: "Plus'a özel", tur: "mor" });
    if (x.fiyatKaynagi === "PREMIUM") l.push({ ad: "Premium'a özel", tur: "mor" });
    if (x.kargoBedavaMi === true) l.push({ ad: "Kargo bedava", tur: "yesil" });
    return l.slice(0, 2);
}

/**
 * İndirim kartı: kartın tamamı indirim detayına götürür (mağaza düğmesi detayda). Props: aciklama (ad), img, indirim
 * ("%30"), fiyat, eskifiyat, subheader (mağaza), oid, incelepath, averageRating, totalCount, telegramaGonderimDurumu
 * (1 = editörün seçimi), indirimDurumu / guncelFiyat (vitrin kontrolü), fiyatGizle (Amazon: fiyat yazılmaz, ortaklık
 * koşulu), kayitTarihi ("X dk önce"), etiketler (kartEtiketleri), izgara (ızgarada tam genişlik).
 */
export default function GenericCardV2(kartProps) {
    const props = kartProps.magaza && MAGAZA_KODU_ADI[kartProps.magaza] ? { ...kartProps, subheader: MAGAZA_KODU_ADI[kartProps.magaza] } : kartProps;
    const [once, setOnce] = useState(null);
    useEffect(() => { setOnce(props.kayitTarihi ? neKadarOnce(props.kayitTarihi) : null); }, [props.kayitTarihi]);

    const detayAdresi = `${props.incelepath}?oid=${props.oid}&name=${encodeURIComponent(props.aciklama || "")}`;
    const detayaGit = () => navigate(detayAdresi);
    // üstüne gelince / dokunur dokunmaz detayın (boş) page-data'sı önceden istenir: tıklamada ağ beklenmez (utils/ssrOnbellek)
    const onceden = () => { try { prefetchPathname(detayAdresi); } catch (e) { /* önemsiz */ } };

    const bitti = props.indirimDurumu === "SONA_ERDI" || props.indirimDurumu === "SATISTA_DEGIL";
    const bittiYazisi = props.indirimDurumu === "SATISTA_DEGIL" ? "Satışta değil" : "İndirim sona erdi";
    const fiyat = sayiyaCevir(props.fiyat);
    const eski = sayiyaCevir(props.eskifiyat);
    const guncel = sayiyaCevir(props.guncelFiyat);
    const puan = sayiyaCevir(props.averageRating);
    const yorum = sayiyaCevir(props.totalCount);
    const editor = Number(props.telegramaGonderimDurumu) === 1;
    const indirim = !props.fiyatGizle && props.indirim && !/undefined|null/.test(props.indirim) ? props.indirim : null;
    const etiketler = props.etiketler || [];
    const etiketListesi = (sinif) => (editor || etiketler.length > 0) && !bitti && (
        <div className={sinif}>
            {editor && <span className="uk-etiket uk-etiket-editor">★ Editörün seçimi</span>}
            {etiketler.slice(0, editor ? 1 : 2).map((e) => (
                <span key={e.ad} className={"uk-etiket" + (e.tur ? " uk-etiket-" + e.tur : "")}>{e.ad}</span>
            ))}
        </div>
    );

    return (
        <article className={"uk" + (props.izgara ? " uk-izgara" : "") + (bitti ? " uk-bitti" : "")} onClick={detayaGit}
            onMouseEnter={onceden} onTouchStart={onceden} onFocus={onceden}
            onKeyDown={(e) => { if (e.key === "Enter") detayaGit(); }} tabIndex={0} title={props.aciklama || undefined}>
            <div className="uk-gorsel">
                {props.img && <img src={props.img} alt={props.aciklama || ""} loading="lazy" />}
                {etiketListesi("uk-ust-etiketler")}
                {bitti && <span className="uk-bitti-yazi">{bittiYazisi}</span>}
                <div className="uk-alt-etiketler">
                    {once ? <span className="uk-zaman">{once}</span> : <span />}
                    {indirim && <span className="uk-indirim">{indirim}</span>}
                </div>
            </div>
            <div className="uk-govde">
                <div className="uk-magaza-satir">
                    <span className="uk-magaza" style={{ color: MAGAZA_RENGI[props.subheader] || "#374151" }}>{props.subheader}</span>
                    {/* yatay kartta (telefon listesi) etiketler görselin üstü yerine burada */}
                    {etiketListesi("uk-govde-etiketler")}
                </div>
                <h3 className="uk-ad">{props.aciklama}</h3>
                <div className="uk-puan">
                    {puan && <><span className="uk-yildiz" aria-hidden="true">★</span><b>{puan.toFixed(1).replace(".", ",")}</b></>}
                    {puan && yorum && <span>({yorum.toLocaleString("tr-TR")})</span>}
                </div>
                <div className="uk-alt">
                    {props.fiyatGizle ? (
                        <span className="uk-gizli">Fiyatı {props.subheader}'da gör →</span>
                    ) : (
                        <>
                            <div className="uk-fiyatlar">
                                {fiyat && <span className="uk-fiyat">{tl(fiyat)}</span>}
                                {eski && fiyat && eski > fiyat && <span className="uk-eski">{tl(eski)}</span>}
                            </div>
                            {props.indirimDurumu === "SONA_ERDI" && guncel && <div className="uk-guncel">şu an {tl(guncel)}</div>}
                        </>
                    )}
                </div>
            </div>
        </article>
    );
}
